import { graphql } from "../gql";

// Query person

export const query = graphql(`
    query AppFirstTimeLoginQuery {
        currentPerson {
            id
            firstName
            lastName
            gender
            title
            tel
            birthYear
            avatar
            eMailNotifications
            user {
                email
            }
        }
        avatar {
            avatars
            avatarPath
        }
        terms {
            terms
            settingsTerms
        }
    }
`);

// First time login mutation

export const mutation = graphql(`
    mutation AppFirstTimeLoginMutation($data: PlayerCurrentPersonFirstTimeData!) {
        currentPersonFirstTimeSetup(data: $data) {
            error
            currentPerson { id }
            redirectUrl
        }
    }
`);
